// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1vOI6","bigColWidth":"Table_bigColWidth__DXTAA","biggerColWidth":"Table_biggerColWidth__1sRhs","row":"Table_row__3TG2H","col":"Table_col__1iqfW"};